
  export default {
    props: {
      title: {
        type: String,
        default: '',
        required: false
      },
      text: {
        type: String,
        default: '',
        required: false
      },
      footerTime: {
        type: String,
        default: '',
        required: false
      },
      authorSlug: {
        type: String,
        default: '',
        required: false
      },
      image: {
        type: String,
        default: '',
        required: false
      },
      linkText: {
        type: String,
        default: ''
      },
      link: {
        type: String,
        default: ''
      },
      hasMobileBadge: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: ''
      }
    },
    computed: {
      splicedText () {
        const text = this.text.replace(/<a\b[^>]*>/i, '').replace(/<\/?[^>]+(>|$)/g, '').slice(0, 200).trim();
        if (this.text.length > 200) {
          if (text.slice(-1) === '.') {
            return text + '..';
          }
          return text + '...';
        } else {
          return text;
        }
      }
    }
  };
